import { render, staticRenderFns } from "./NewYN.vue?vue&type=template&id=47350220"
import script from "./NewYN.vue?vue&type=script&lang=js"
export * from "./NewYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports